import {
    extractUrlContext,
    getCityDisplayName,
    getBrandDisplayName,
    getModelDisplayName,
} from './urlContext';

const CATEGORY_BY_TYPE = {
    search_car: 'car',
    search_bike: 'bike',
    search_commercial: 'commercial',
    search_parts: 'parts',
    search_parts_car: 'parts_car',
    search_parts_bike: 'parts_bike',
    search_parts_commercial: 'parts_commercial',
    search_rent_car: 'rent_car',
    search_rent_bike: 'rent_bike',
    search_rent_commercial: 'rent_commercial',
};

const BRAND_LABEL_KA = 'მანქანების';
const BIKE_LABEL_KA = 'მოტოციკლების';
const COMMERCIAL_LABEL_KA = 'სატვირთო მანქანების';
const PARTS_LABEL_KA = 'ავტონაწილების';

export function toGeLocative(name) {
    if (!name) return '';
    if (name.endsWith('ში')) return name;
    return name.endsWith('ი') ? `${name.slice(0, -1)}ში` : `${name}ში`;
}

const TITLE_TEMPLATES = {
    car: {
        ge: {
            city: (city) =>
                `მანქანების ყიდვა-გაყიდვა ${toGeLocative(city)} — 1000+ მეორადი ავტო | Worldauto.ge`,
            brand: (brand) =>
                `${brand} საქართველოში — ყიდვა-გაყიდვა | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} ${toGeLocative(city)} — ყიდვა-გაყიდვა | Worldauto.ge`,
            brandModel: (brand, model) =>
                `${brand} ${model} საქართველოში | Worldauto.ge`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} ${toGeLocative(city)} | Worldauto.ge`,
        },
        ru: {
            city: (city) =>
                `Купить авто в ${city} б/у — от $2,000 | Worldauto.ge`,
            brand: (brand) => `Купить ${brand} в Грузии — б/у | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Купить ${brand} в ${city} | Worldauto.ge`,
            brandModel: (brand, model) =>
                `Купить ${brand} ${model} в Грузии | Worldauto.ge`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} в ${city} | Worldauto.ge`,
        },
        en: {
            city: (city) =>
                `Used Cars for Sale in ${city} | Worldauto.ge`,
            brand: (brand) => `${brand} for sale in Georgia | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} in ${city}, Georgia | Worldauto.ge`,
            brandModel: (brand, model) =>
                `${brand} ${model} for sale in Georgia | Worldauto.ge`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} in ${city} | Worldauto.ge`,
        },
        ua: {
            city: (city) =>
                `Купити авто у ${city} б/в | Worldauto.ge`,
            brand: (brand) =>
                `Купити ${brand} у Грузії — вживані | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Купити ${brand} у ${city} | Worldauto.ge`,
            brandModel: (brand, model) =>
                `Купити ${brand} ${model} у Грузії | Worldauto.ge`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} у ${city} | Worldauto.ge`,
        },
    },
    bike: {
        ge: {
            city: (city) =>
                `${BIKE_LABEL_KA} ყიდვა-გაყიდვა ${toGeLocative(city)} — Worldauto.ge`,
            brand: (brand) =>
                `${brand} მოტოციკლები საქართველოში | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} მოტოციკლები ${toGeLocative(city)} | Worldauto.ge`,
        },
        ru: {
            city: (city) => `Купить мотоцикл в ${city} | Worldauto.ge`,
            brand: (brand) =>
                `Купить мотоцикл ${brand} в Грузии | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Мотоцикл ${brand} в ${city} | Worldauto.ge`,
        },
        en: {
            city: (city) =>
                `Motorcycles for sale in ${city}, Georgia | Worldauto.ge`,
            brand: (brand) => `${brand} motorcycles in Georgia | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} motorcycles in ${city} | Worldauto.ge`,
        },
        ua: {
            city: (city) => `Мотоцикли у ${city}, Грузія | Worldauto.ge`,
            brand: (brand) => `${brand} мотоцикли у Грузії | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} мотоцикли у ${city} | Worldauto.ge`,
        },
    },
    commercial: {
        ge: {
            city: (city) =>
                `${COMMERCIAL_LABEL_KA} ${toGeLocative(city)} — Worldauto.ge`,
            brand: (brand) => `${brand} სატვირთო საქართველოში | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} სატვირთო ${toGeLocative(city)} | Worldauto.ge`,
        },
        ru: {
            city: (city) =>
                `Грузовики и коммерческий транспорт в ${city} | Worldauto.ge`,
            brand: (brand) => `${brand} грузовики в Грузии | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} грузовики в ${city} | Worldauto.ge`,
        },
        en: {
            city: (city) =>
                `Commercial vehicles in ${city}, Georgia | Worldauto.ge`,
            brand: (brand) => `${brand} trucks in Georgia | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} trucks in ${city} | Worldauto.ge`,
        },
        ua: {
            city: (city) => `Вантажівки у ${city}, Грузія | Worldauto.ge`,
            brand: (brand) => `${brand} вантажівки у Грузії | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} вантажівки у ${city} | Worldauto.ge`,
        },
    },
    rent_car: {
        ge: {
            city: (city) =>
                `ავტოს ქირაობა ${toGeLocative(city)} — დღიური ფასი | Worldauto.ge`,
            brand: (brand) => `${brand} ქირაობა საქართველოში | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} ქირაობა ${toGeLocative(city)} | Worldauto.ge`,
        },
        ru: {
            city: (city) => `Аренда авто в ${city} — посуточно | Worldauto.ge`,
            brand: (brand) => `Аренда ${brand} в Грузии | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Аренда ${brand} в ${city} | Worldauto.ge`,
        },
        en: {
            city: (city) => `Car rental in ${city}, Georgia | Worldauto.ge`,
            brand: (brand) => `Rent a ${brand} in Georgia | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Rent a ${brand} in ${city} | Worldauto.ge`,
        },
        ua: {
            city: (city) => `Оренда авто у ${city}, Грузія | Worldauto.ge`,
            brand: (brand) => `Оренда ${brand} у Грузії | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Оренда ${brand} у ${city} | Worldauto.ge`,
        },
    },
    rent_bike: {
        ge: {
            city: (city) =>
                `მოტოციკლის ქირაობა ${toGeLocative(city)} | Worldauto.ge`,
            brand: (brand) =>
                `${brand} მოტოციკლის ქირაობა საქართველოში | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} მოტოციკლის ქირაობა ${toGeLocative(city)} | Worldauto.ge`,
        },
        ru: {
            city: (city) => `Аренда мотоцикла в ${city} | Worldauto.ge`,
            brand: (brand) =>
                `Аренда мотоцикла ${brand} в Грузии | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Аренда мотоцикла ${brand} в ${city} | Worldauto.ge`,
        },
        en: {
            city: (city) =>
                `Motorcycle rental in ${city}, Georgia | Worldauto.ge`,
            brand: (brand) =>
                `Rent a ${brand} motorcycle in Georgia | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Rent a ${brand} motorcycle in ${city} | Worldauto.ge`,
        },
        ua: {
            city: (city) => `Оренда мотоцикла у ${city}, Грузія | Worldauto.ge`,
            brand: (brand) =>
                `Оренда ${brand} мотоцикла у Грузії | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Оренда ${brand} мотоцикла у ${city} | Worldauto.ge`,
        },
    },
    parts: {
        ge: {
            city: (city) =>
                `${PARTS_LABEL_KA} ყიდვა-გაყიდვა ${toGeLocative(city)} | Worldauto.ge`,
            brand: (brand) => `${brand} ნაწილები საქართველოში | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} ნაწილები ${toGeLocative(city)} | Worldauto.ge`,
        },
        ru: {
            city: (city) => `Автозапчасти в ${city} | Worldauto.ge`,
            brand: (brand) => `Запчасти ${brand} в Грузии | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Запчасти ${brand} в ${city} | Worldauto.ge`,
        },
        en: {
            city: (city) => `Auto parts in ${city}, Georgia | Worldauto.ge`,
            brand: (brand) => `${brand} parts in Georgia | Worldauto.ge`,
            brandCity: (brand, city) =>
                `${brand} parts in ${city} | Worldauto.ge`,
        },
        ua: {
            city: (city) => `Автозапчастини у ${city}, Грузія | Worldauto.ge`,
            brand: (brand) => `Запчастини ${brand} у Грузії | Worldauto.ge`,
            brandCity: (brand, city) =>
                `Запчастини ${brand} у ${city} | Worldauto.ge`,
        },
    },
};

const DESCRIPTION_TEMPLATES = {
    car: {
        ge: {
            city: (city) =>
                `მანქანების ყიდვა-გაყიდვა ${toGeLocative(city)} — 1000+ მეორადი და ახალი ავტო ფასი 2 000$-დან ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ VIN შემოწმება ✓ უფასო განცხადება — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} საქართველოში — მეორადი და ახალი ავტომობილების ფასები, ფოტოები, კატალოგი ✓ უფასო განცხადება ✓ 0% საკომისიო ✓ VIN შემოწმება — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} ${toGeLocative(city)} — ფასები, ფოტოები, კატალოგი ✓ მეორადი და ახალი ✓ უფასო განცხადება ✓ 0% საკომისიო ✓ VIN შემოწმება — Worldauto.ge.`,
            brandModel: (brand, model) =>
                `${brand} ${model} საქართველოში — ფასები, ფოტოები, კატალოგი ✓ მეორადი და ახალი ✓ უფასო განცხადება ✓ 0% საკომისიო — Worldauto.ge.`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} ${toGeLocative(city)} — ფასები, ფოტოები, კატალოგი ✓ მეორადი და ახალი ✓ VIN შემოწმება — Worldauto.ge.`,
        },
        ru: {
            city: (city) =>
                `Купить б/у авто в ${city}, Грузия — от $2,000 ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ VIN-проверка ✓ частные продавцы и дилеры — Worldauto.ge.`,
            brand: (brand) =>
                `Купить ${brand} в Грузии — б/у и новые, цены, фото и каталог ✓ VIN-проверка ✓ бесплатное объявление ✓ 0% комиссии — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Купить ${brand} в ${city} — цены, фото и каталог ✓ б/у и новые ✓ VIN-проверка ✓ бесплатное объявление — Worldauto.ge.`,
            brandModel: (brand, model) =>
                `Купить ${brand} ${model} в Грузии — цены, фото и каталог ✓ б/у и новые ✓ VIN-проверка — Worldauto.ge.`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} в ${city} — цены, фото и каталог ✓ б/у и новые ✓ VIN-проверка — Worldauto.ge.`,
        },
        en: {
            city: (city) =>
                `Buy used cars in ${city}, Georgia — from $2,000 ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ VIN check ✓ private sellers and dealers ✓ free listings — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} for sale in Georgia — used and new, prices, photos and catalog ✓ VIN check ✓ free listings — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} in ${city}, Georgia — prices, photos and catalog ✓ used and new ✓ VIN check ✓ free listings — Worldauto.ge.`,
            brandModel: (brand, model) =>
                `${brand} ${model} for sale in Georgia — prices, photos and full catalog ✓ used and new ✓ VIN check — Worldauto.ge.`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} in ${city} — prices, photos and full catalog ✓ used and new ✓ VIN check — Worldauto.ge.`,
        },
        ua: {
            city: (city) =>
                `Купити б/в авто у ${city}, Грузія — від $2,000 ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ Перевірка VIN — Worldauto.ge.`,
            brand: (brand) =>
                `Купити ${brand} у Грузії — вживані та нові, ціни, фото та каталог ✓ VIN-перевірка ✓ безкоштовне оголошення — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Купити ${brand} у ${city} — ціни, фото та каталог ✓ вживані та нові ✓ VIN-перевірка — Worldauto.ge.`,
            brandModel: (brand, model) =>
                `Купити ${brand} ${model} у Грузії — ціни, фото та каталог ✓ VIN-перевірка — Worldauto.ge.`,
            brandModelCity: (brand, model, city) =>
                `${brand} ${model} у ${city} — ціни, фото та каталог ✓ VIN-перевірка — Worldauto.ge.`,
        },
    },
    bike: {
        ge: {
            city: (city) =>
                `მოტოციკლების ყიდვა-გაყიდვა ${toGeLocative(city)} — Honda, Yamaha, Kawasaki, BMW, KTM, Suzuki ✓ უფასო განცხადება ✓ 0% საკომისიო ✓ კერძო გამყიდველები და დილერები — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} მოტოციკლები საქართველოში — ფასები, ფოტოები, კატალოგი ✓ მეორადი და ახალი ✓ უფასო განცხადება — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} მოტოციკლები ${toGeLocative(city)} — ფასები, ფოტოები, კატალოგი ✓ მეორადი და ახალი — Worldauto.ge.`,
        },
        ru: {
            city: (city) =>
                `Купить мотоцикл в ${city}, Грузия — Honda, Yamaha, Kawasaki, BMW ✓ б/у мото, цены и фото ✓ бесплатное объявление — Worldauto.ge.`,
            brand: (brand) =>
                `Купить мотоцикл ${brand} в Грузии — цены, фото и каталог ✓ б/у и новые ✓ бесплатное объявление — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Мотоцикл ${brand} в ${city} — цены, фото и каталог ✓ б/у и новые — Worldauto.ge.`,
        },
        en: {
            city: (city) =>
                `Motorcycles for sale in ${city}, Georgia — Honda, Yamaha, Kawasaki, BMW ✓ used bikes, prices, photos ✓ free listings — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} motorcycles in Georgia — prices, photos and full catalog ✓ used and new ✓ free listings — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} motorcycles in ${city}, Georgia — prices, photos and catalog ✓ used and new — Worldauto.ge.`,
        },
        ua: {
            city: (city) =>
                `Мотоцикли у ${city}, Грузія — Honda, Yamaha, Kawasaki, BMW ✓ вживані мото, ціни та фото — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} мотоцикли у Грузії — ціни, фото та каталог ✓ вживані та нові — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} мотоцикли у ${city} — ціни, фото та каталог — Worldauto.ge.`,
        },
    },
    commercial: {
        ge: {
            city: (city) =>
                `სატვირთო და კომერციული ავტომობილების ყიდვა-გაყიდვა ${toGeLocative(city)} — Mercedes Sprinter, Ford Transit, MAN, Scania, DAF ✓ უფასო განცხადება — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} სატვირთო და კომერციული საქართველოში — ფასები, ფოტოები, კატალოგი — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} სატვირთო ${toGeLocative(city)} — ფასები, ფოტოები, კატალოგი — Worldauto.ge.`,
        },
        ru: {
            city: (city) =>
                `Грузовики и коммерческий транспорт в ${city}, Грузия — Mercedes Sprinter, Ford Transit, MAN — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} грузовики и коммерческий транспорт в Грузии — цены, фото и каталог — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} грузовики в ${city} — цены, фото и каталог — Worldauto.ge.`,
        },
        en: {
            city: (city) =>
                `Commercial vehicles in ${city}, Georgia — Mercedes Sprinter, Ford Transit, MAN, Scania — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} commercial vehicles in Georgia — prices, photos and full catalog — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} trucks in ${city}, Georgia — prices, photos and catalog — Worldauto.ge.`,
        },
        ua: {
            city: (city) =>
                `Вантажівки та комерційний транспорт у ${city}, Грузія — Mercedes Sprinter, Ford Transit — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} вантажівки у Грузії — ціни, фото та каталог — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} вантажівки у ${city} — ціни, фото та каталог — Worldauto.ge.`,
        },
    },
    rent_car: {
        ge: {
            city: (city) =>
                `ავტოს ქირაობა ${toGeLocative(city)} — დღიური ფასი 30 ₾-დან ✓ Toyota, Hyundai, BMW, Mercedes ✓ სწრაფი დაჯავშნა ✓ დაზღვევა — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} ქირაობა საქართველოში — დღიური ფასი, ფოტოები, ჯავშანი ✓ დაზღვევა — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} ქირაობა ${toGeLocative(city)} — დღიური ფასი, ფოტოები, ჯავშანი — Worldauto.ge.`,
        },
        ru: {
            city: (city) =>
                `Аренда авто в ${city}, Грузия — посуточно от 30 ₾ ✓ Toyota, Hyundai, BMW ✓ быстрое бронирование ✓ страховка — Worldauto.ge.`,
            brand: (brand) =>
                `Аренда ${brand} в Грузии — суточные цены, фото и бронирование ✓ страховка — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Аренда ${brand} в ${city} — суточные цены, фото и бронирование — Worldauto.ge.`,
        },
        en: {
            city: (city) =>
                `Car rental in ${city}, Georgia — from 30 ₾/day ✓ Toyota, Hyundai, BMW ✓ fast booking ✓ insurance — Worldauto.ge.`,
            brand: (brand) =>
                `Rent a ${brand} in Georgia — daily rates, photos and booking ✓ insurance — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Rent a ${brand} in ${city}, Georgia — daily rates, photos and booking — Worldauto.ge.`,
        },
        ua: {
            city: (city) =>
                `Оренда авто у ${city}, Грузія — подобово від 30 ₾ ✓ Toyota, Hyundai, BMW ✓ швидке бронювання — Worldauto.ge.`,
            brand: (brand) =>
                `Оренда ${brand} у Грузії — добові ціни, фото та бронювання — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Оренда ${brand} у ${city} — добові ціни, фото та бронювання — Worldauto.ge.`,
        },
    },
    rent_bike: {
        ge: {
            city: (city) =>
                `მოტოციკლის ქირაობა ${toGeLocative(city)} — Honda, Yamaha, BMW, Harley-Davidson ✓ დღიური ფასი ✓ სწრაფი დაჯავშნა — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} მოტოციკლის ქირაობა საქართველოში — დღიური ფასი, ჯავშანი — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} მოტოციკლის ქირაობა ${toGeLocative(city)} — დღიური ფასი, ჯავშანი — Worldauto.ge.`,
        },
        ru: {
            city: (city) =>
                `Аренда мотоцикла в ${city}, Грузия — Honda, Yamaha, BMW ✓ посуточно ✓ быстрое бронирование — Worldauto.ge.`,
            brand: (brand) =>
                `Аренда мотоцикла ${brand} в Грузии — суточные цены и бронирование — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Аренда мотоцикла ${brand} в ${city} — суточные цены и бронирование — Worldauto.ge.`,
        },
        en: {
            city: (city) =>
                `Motorcycle rental in ${city}, Georgia — Honda, Yamaha, BMW ✓ daily rates ✓ fast booking — Worldauto.ge.`,
            brand: (brand) =>
                `Rent a ${brand} motorcycle in Georgia — daily rates and booking — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Rent a ${brand} motorcycle in ${city} — daily rates and booking — Worldauto.ge.`,
        },
        ua: {
            city: (city) =>
                `Оренда мотоцикла у ${city}, Грузія — Honda, Yamaha, BMW ✓ подобово — Worldauto.ge.`,
            brand: (brand) =>
                `Оренда ${brand} мотоцикла у Грузії — добові ціни та бронювання — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Оренда ${brand} мотоцикла у ${city} — добові ціни — Worldauto.ge.`,
        },
    },
    parts: {
        ge: {
            city: (city) =>
                `ავტონაწილების ყიდვა-გაყიდვა ${toGeLocative(city)} — ძრავა, კოლოფი, კარდანი, სამუხრუჭე, ელექტრიკა ✓ ახალი და მეორადი ✓ უფასო განცხადება — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} ნაწილების ყიდვა საქართველოში — ძრავა, კოლოფი, კარდანი, ელექტრიკა ✓ ახალი და მეორადი — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} ნაწილები ${toGeLocative(city)} — ძრავა, კოლოფი, ელექტრიკა ✓ ახალი და მეორადი — Worldauto.ge.`,
        },
        ru: {
            city: (city) =>
                `Купить автозапчасти в ${city}, Грузия — двигатели, КПП, тормоза, электрика ✓ новые и б/у ✓ объявления и магазины — Worldauto.ge.`,
            brand: (brand) =>
                `Купить запчасти ${brand} в Грузии — двигатели, КПП, тормоза, электрика ✓ новые и б/у — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Запчасти ${brand} в ${city} — двигатели, КПП, электрика ✓ новые и б/у — Worldauto.ge.`,
        },
        en: {
            city: (city) =>
                `Auto parts in ${city}, Georgia — engines, gearboxes, brakes, electrics ✓ new and used ✓ listings and shops — Worldauto.ge.`,
            brand: (brand) =>
                `${brand} parts in Georgia — engines, gearboxes, brakes, electrics ✓ new and used — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `${brand} parts in ${city}, Georgia — engines, gearboxes, electrics ✓ new and used — Worldauto.ge.`,
        },
        ua: {
            city: (city) =>
                `Автозапчастини у ${city}, Грузія — двигуни, КПП, гальма, електрика ✓ нові та б/в — Worldauto.ge.`,
            brand: (brand) =>
                `Запчастини ${brand} у Грузії — двигуни, КПП, гальма ✓ нові та б/в — Worldauto.ge.`,
            brandCity: (brand, city) =>
                `Запчастини ${brand} у ${city} — двигуни, КПП, електрика — Worldauto.ge.`,
        },
    },
};

function getCategory(type) {
    return CATEGORY_BY_TYPE[type];
}

function pickTemplate(map, ctx) {
    if (ctx.brandSlug && ctx.modelSlug && ctx.citySlug && map.brandModelCity) { return 'brandModelCity'; }
    if (ctx.brandSlug && ctx.modelSlug && map.brandModel) return 'brandModel';
    if (ctx.brandSlug && ctx.citySlug && map.brandCity) return 'brandCity';
    if (ctx.brandSlug && map.brand) return 'brand';
    if (ctx.citySlug && map.city) return 'city';
    return null;
}

export function getLandingTitle(pathname, type, lang, t) {
    const category = getCategory(type);
    if (!category) return null;

    const ctx = extractUrlContext(pathname);
    if (!ctx.citySlug && !ctx.brandSlug) return null;

    const map =
        TITLE_TEMPLATES[category]?.[lang] || TITLE_TEMPLATES[category]?.en;
    if (!map) return null;

    const key = pickTemplate(map, ctx);
    if (!key) return null;

    const brand = getBrandDisplayName(ctx.brandSlug);
    const model = getModelDisplayName(ctx.modelSlug);
    const city = getCityDisplayName(ctx.citySlug, lang, t);

    switch (key) {
        case 'brandModelCity':
            return map.brandModelCity(brand, model, city);
        case 'brandModel':
            return map.brandModel(brand, model);
        case 'brandCity':
            return map.brandCity(brand, city);
        case 'brand':
            return map.brand(brand);
        case 'city':
            return map.city(city);
        default:
            return null;
    }
}

export function getLandingDescription(pathname, type, lang, t) {
    const category = getCategory(type);
    if (!category) return null;

    const ctx = extractUrlContext(pathname);
    if (!ctx.citySlug && !ctx.brandSlug) return null;

    const map =
        DESCRIPTION_TEMPLATES[category]?.[lang] ||
        DESCRIPTION_TEMPLATES[category]?.en;
    if (!map) return null;

    const key = pickTemplate(map, ctx);
    if (!key) return null;

    const brand = getBrandDisplayName(ctx.brandSlug);
    const model = getModelDisplayName(ctx.modelSlug);
    const city = getCityDisplayName(ctx.citySlug, lang, t);

    switch (key) {
        case 'brandModelCity':
            return map.brandModelCity(brand, model, city);
        case 'brandModel':
            return map.brandModel(brand, model);
        case 'brandCity':
            return map.brandCity(brand, city);
        case 'brand':
            return map.brand(brand);
        case 'city':
            return map.city(city);
        default:
            return null;
    }
}
